export default (image, aspect = image.width / image.height) => {
  const sizes = [];

  const widths = [
    30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360,
    390, 420, 450, 480, 510, 540, 570, 600, 630, 660, 690, 720,
    750, 780, 810, 840, 870, 900, 930, 960, 1020, 1080, 1140, 1200,
    1260, 1320, 1380, 1440, 1500, 1560, 1620, 1680, 1740, 1800, 1860, 1920,
    2040, 2160, 2280, 2400, 2520, 2640, 2760, 2880,
  ];

  for (let i = 0; i < widths.length; i += 1) {
    const width = widths[i];
    const height = width / aspect;

    if (image.width <= width) {
      break;
    }

    if (image.height <= height) {
      break;
    }

    sizes.push(width);
  }

  return `
  <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
     data-src="${Shopify.Image.getSizedImageUrl(image.src ?? image.url, '{width}x{height}_crop_center')}"
     data-aspectratio="${aspect}"
     data-sizes="auto"
     data-widths="[${sizes.join(',')}]"
     alt="${image.alt ?? ''}"
     class="lazyload">
  `;
};
